import React, { useContext, useEffect, useState } from "react";
import {
	Button,
	Form,
	Modal
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LoaderContext } from "../../../App";
import { LS_AUTHORITY_KEY } from "../../../core/constants/common";
import KPIService from "../../../core/service/KPIService";
import ReactDatePicker from "react-datepicker";
import moment from "moment";

function KPIGoalModal({ t, goalToUpdate, onHide, onSave }) {

	const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const companyId = lsData.profile.company.id;
	const { setLoaderDisplay } = useContext(LoaderContext);
	const [formData, setFormData] = useState(goalToUpdate?.id > 0 ? goalToUpdate : {
		ownerId: companyId,
		name: '',
		category: '',
		description: '',
		timelineStart: '',
		timelineEnd: '',
	});
	const [validated, setValidated] = useState(false);
	const [categories, setCategories] = useState([]);

	useEffect(() => {
		fetchCategories();
	}, []);

	const fetchCategories = () => {
		KPIService.listKPICategory(companyId).then(res => {
			if (res.status !== 200) return;

			setCategories(res.data.data ?? []);
		}).catch(err => { });
	};

	const saveData = (e) => {

		setValidated(true);
		e.preventDefault();
		const goalForm = e.currentTarget;
		if (goalForm.checkValidity() === false) {
			e.stopPropagation();
			toast.warning('Please fill all the mandatory fields');
			return;
		}
		setLoaderDisplay(true);
		const fData = JSON.parse(JSON.stringify(formData));
		if (fData.id === 0) {
			delete fData.id;
		}
		KPIService.createOrUpdateGoal(fData).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200 && res.status !== 201) return;

			toast.success("Success", {
				position: toast.POSITION.TOP_RIGHT,
			});
			onSave();
		}).catch((error) => {
			setLoaderDisplay(false);
		});
	};

	return (
		<>
			<Modal show={true} onHide={() => onHide()}
				aria-labelledby="contained-modal-title-vcenter"
				size="lg"

				centered>
				<Modal.Header closeButton className="border-0">
					< Modal.Title as="h5">{goalToUpdate?.id > 0 ? t('UpdateGoal.label') : t('AddGoal.label')}</Modal.Title>
				</Modal.Header>
				<Modal.Body className="">
					<Form noValidate validated={validated} onSubmit={saveData}>
						<div className="row m-0">
							<div className="col-lg-6 p-2">
								<label className="mb-1">{t("DefineYourGoal.label")} <span className="text-danger">*</span></label>
								<input
									type="text"
									className="form-control"
									onChange={(e) => setFormData({ ...formData, name: e.target.value })}
									value={formData.name}
									placeholder={t("ReduceCarbonEmissions.label")}
									required />
							</div>
							<div className="col-lg-6 p-2">
								<div className="d-flex justify-content-between">
									<label className="mb-1">{t("Category.label")} <span className="text-danger">*</span></label>
								</div>
								<select className="form-select"
									required
									value={formData.category}
									onChange={(e) => setFormData({ ...formData, category: e.target.value })}>
									<option value='' key=''>{t("Select.label")}</option>
									{
										categories?.map((cat) => (
											<option value={cat.category} key={cat.id}>{cat.category}</option>
										))
									}
								</select>
							</div>
						</div>
						<div className="p-2">
							<label htmlFor="desc" className="mb-1">{t("Description.label")}</label>
							<textarea
								className="form-control"
								rows={5}
								onChange={(e) => setFormData({ ...formData, description: e.target.value })}
								defaultValue={formData.description}
								placeholder={t("ReduceCarbonEmissionsRenewableEnergy.label")}
							></textarea>
						</div>
						<div className="row m-0">
							<div className="col-lg-12 px-2">
								<label className="mb-1">{t('TimelineToAchieveTheGoal.label')} <span className="text-danger">*</span></label>
							</div>
							<div className="col-lg-3 p-2 pt-1">
								<ReactDatePicker
									selected={formData.timelineStart ? new Date(formData.timelineStart) : null}
									onChange={(date) => {
										setFormData({
											...formData,
											timelineStart: moment(date).format('YYYY-MM-DD')
										});
									}}
									className="form-control"
									dateFormat="dd/MM/yyyy"
									placeholderText={t("Startdate.label")}
									required />
							</div>
							<div className="col-lg-3 p-2 pt-1">
								<ReactDatePicker
									selected={formData.timelineEnd ? new Date(formData.timelineEnd) : null}
									onChange={(date) => {
										setFormData({
											...formData,
											timelineEnd: moment(date).format('YYYY-MM-DD')
										});
									}}
									className="form-control"
									dateFormat="dd/MM/yyyy"
									placeholderText={t("Enddate.label")}
									required />
							</div>
						</div>
						<div className="text-center p-2">
							<Button variant="secondary" className="mx-2" onClick={() => onHide()}>{t('Cancel.label')}</Button>
							<button type="submit" className="btn btn-primary px-4">{t('Save.label')}</button>
						</div>
					</Form>
				</Modal.Body>
			</Modal>
		</>
	);
}

export default withTranslation()(KPIGoalModal);

